import { useEffect, useState } from "react";
import { Container, Col, Row } from "react-bootstrap";
import { Banner } from '@veeyaainnovatives/banner';
import Bannerimg from '../assets/images/gallery/gallery-1.jpg';
import { Link } from "react-router-dom";
import axios from 'axios';
import { getApiUrl } from '../config/api';
import ServiceNotFound from "../components/sections/service-not-found";

const Services = () => {

  const pageDetails = {
    title: `Our **Service** Packages & Solution`,
    description: "Explore our comprehensive service packages and solutions designed to meet your needs.",
    breadcrumb: [
      { name: "Home", link: "/" },
      { name: "Services", link: "/services" }
    ],
  }

  const [servicesData, setServicesData] = useState([]);
  const [servicesLoading, setServicesLoading] = useState(true);

  // Fetch services from API
  useEffect(() => {
    const fetchServices = async () => {
      try {
        setServicesLoading(true);
        const response = await axios.get(getApiUrl('api/public/services/all-with-children'));

        if (response.data.success && response.data.data) {
          setServicesData(response.data.data);
        } else {
          setServicesData([]);
        }
      } catch (error) {
        console.error('Error fetching services:', error);
        setServicesData([]);
      } finally {
        setServicesLoading(false);
      }
    };

    fetchServices();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <Banner img={Bannerimg} pageDetails={pageDetails} highlightClassName="theme-color-green" />
      <div className="body-wrap overflow-hidden">


        <section className="section">
          <Container>

            {/* Services Section */}

            {servicesLoading ? (
              <div className="text-center py-5">
                <section className="loading-screen height-25-p">
                  <div className="loader-wrapper">
                    <div className="spinner"></div>
                    <h4 className="loading-text">Loading ...</h4>
                  </div>
                </section>
              </div>
            ) : servicesData.length === 0 ? (
              <div className="text-center py-5">
                <ServiceNotFound />
              </div>
            ) : (
              servicesData.map((service) => (
                <div key={service.id} className="upcoming-batches-card">
                  <Row>
                    <Col xl={2} lg={2}>
                      <div className="calendar-card mx-lg-auto mt-3">
                        <h1 className="date">
                          <i className={service.icon || "fa-regular fa-copy"}></i>
                        </h1>
                      </div>
                    </Col>
                    <Col xl={9} lg={9}>
                      <h1 className="title">{service.title}</h1>

                      {/* Show excerpt only */}
                      {service.excerpt && (
                        <p className="course-list mt-0 mb-3">
                          {service.excerpt}
                        </p>
                      )}

                      {/* Sub Services */}
                      {service.sub_services && service.sub_services.length > 0 && (
                        <>
                          <h2 className='sub-service-title'>Sub Services</h2>
                          {service.sub_services.map((subService) => (
                            <Link
                              key={subService.id}
                              to={`/services/${subService.slug}`}
                              className="course-list mt-0 mb-3 d-block"
                            >
                              <i className="fa-solid fa-angles-right"></i>
                              <span className="ms-3">{subService.title}</span>
                            </Link>
                          ))}
                        </>
                      )}

                      <br />
                    </Col>
                  </Row>
                </div>
              ))
            )}



          </Container>
        </section>

      </div>
    </>



  )
}

export default Services;